import {
    decodeJsonObjectBase64Url,
    encodeJsonObjectBase64Url,
} from './jsonBase64Url'

// Hex / `#rgb` / `#rrggbb` → 0xRRGGBB (invalid → white).
export function colorStringToRgbUint32(color: string): number {
    let s = color.trim()
    if (!s) {
        return 0xffffff
    }
    if (s.startsWith('#')) {
        s = s.slice(1)
    }
    if (s.length === 3) {
        s = s
            .split('')
            .map((c) => c + c)
            .join('')
    }
    if (!/^[0-9a-fA-F]{6}$/.test(s)) {
        return 0xffffff
    }
    return parseInt(s, 16) >>> 0
}

export function rgbUint32ToHexColor(n: number): string {
    const v = Math.max(0, Math.min(0xffffff, Math.floor(n))) >>> 0
    return `#${v.toString(16).padStart(6, '0').toUpperCase()}`
}

export function chameleonTextureStringToNum(s: string): number {
    const t = s.trim()
    if (!t) {
        return 0
    }
    const parsed = parseInt(t, 10)
    return Number.isFinite(parsed) ? Math.max(0, parsed) : 0
}

export type ChameleonTextureNumToStoreOptions = {
    min?: number
    max?: number
}

export function chameleonTextureNumToStoreString(
    n: number,
    options?: ChameleonTextureNumToStoreOptions,
): string {
    let value = Math.max(0, Math.floor(n))
    if (options?.min != null) {
        value = Math.max(options.min, value)
    }
    if (options?.max != null) {
        value = Math.min(options.max, value)
    }
    return String(value).padStart(2, '0')
}

export function isFiniteNumber(n: unknown): n is number {
    return typeof n === 'number' && Number.isFinite(n)
}

export function encodeNumericShareTuple(tuple: number[]): string {
    return encodeJsonObjectBase64Url(tuple)
}

export function decodeNumericShareTuple<T>(
    paramValue: string,
    expectedLength: number,
    toPayload: (tuple: number[]) => T | null,
): T | null {
    const trimmed = paramValue.trim()
    if (!trimmed) {
        return null
    }
    const data = decodeJsonObjectBase64Url<unknown>(trimmed)
    if (data == null || !Array.isArray(data)) {
        return null
    }
    if (data.length !== expectedLength) {
        return null
    }
    for (let i = 0; i < expectedLength; i++) {
        if (!isFiniteNumber(data[i])) {
            return null
        }
    }
    return toPayload(data as number[])
}
